import { SxProps, Theme } from '@mui/material';

export const getTaskChipStyles = (
     isDragging: boolean,
     isSelected: boolean,
     task: any,
     canDeleteTask: (task: any) => boolean
): SxProps<Theme> => ({
     cursor: 'pointer',
     color: '#000000',
     boxShadow: isDragging ? '0 4px 8px rgba(0,0,0,0.15)' : 'none',
     opacity: isDragging ? 0.8 : 1,
     ...(task.isApplicable && !isSelected && {
          borderColor: '#2e7d32',
          '&:hover': {
               borderColor: '#1b5e20',
               backgroundColor: '#e8f5e8',
          }
     }),
     '&:hover': {
          backgroundColor: isSelected
               ? 'primary.main'
               : task.isApplicable
                    ? '#e8f5e8'
                    : '#ffebee',
     },
     '& .MuiChip-deleteIcon': {
          fontSize: '16px',
          color: '#000000',
          '&:hover': {
               color: '#d32f2f',
          },
          opacity: canDeleteTask(task) ? 1 : 0.3,
          cursor: canDeleteTask(task) ? 'pointer' : 'not-allowed',
     },
     '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
     },
}); 